import React, {PropsWithChildren, useContext, useState} from "react";
import {createCommentAsync, getCommentsAsync} from "../api/CommentsApi";
import {Comment} from "../models/comment.model";
import {PreviewDataContext} from "./PreviewContext";
import {PreloaderContext} from "./PreloaderContext";
import {ToastService} from "../service/ToastService";

interface CommentContextState {
    comments: Comment[];
    loadComments: () => void;
    isCommentsLoading: boolean;
    createComment: (commentText: string) => void;
}

export const CommentContext = React.createContext({} as CommentContextState);

export const CommentProvider: React.FunctionComponent<PropsWithChildren> = ({children}) => {
    const [comments, setComments] = useState<Comment[]>([]);
    const [isCommentsLoading, setCommentsLoading] = useState<boolean>(false);
    const previewContext = useContext(PreviewDataContext);
    const preloaderContext = useContext(PreloaderContext);

    async function loadComments() {
        setCommentsLoading(true);
        let comments = await getCommentsAsync(previewContext.isPreviewMode);
        setComments(comments);
        setCommentsLoading(false);
    }

    async function createComment(commentText: string) {
        preloaderContext.showMiddlePagePreloader();
        const response = await createCommentAsync(commentText)
            .catch(() => {

            });
        if (response && !response.error && response.response) {
            comments.unshift(response.response);
            setComments(comments);
        } else if (!response || (response && response.error)) {
            if (response && response.errors && response.errors.length) {
                ToastService.middleScreenErrorToast(response.errors.join('\n'));
            } else {
                ToastService.middleScreenErrorToast('Please try again or contact FieldPulse support.');
            }
        }
        preloaderContext.hideMiddlePagePreloader();
    }

    return (
        <CommentContext.Provider value={{comments, loadComments, isCommentsLoading, createComment}}>
            {children}
        </CommentContext.Provider>
    )
}
